
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <v-row class="d-flex justify-center mt-3">
                <v-col cols="3">
                    <v-text-field
                    label="Nome da aba"
                    v-model="form.filters.aba"
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-text-field
                    label="Nome de exibição"
                    v-model="form.filters.nomeDeExibicao"
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
                <sigfoco-select-ativo
                    :cols="2"
                    v-model="form.filters.situacao"
                    labelType="Situação"
                ></sigfoco-select-ativo>
              </v-row>
                <v-row class="d-flex justify-center mt-3">
                <sigfoco-date-picker
                :cols="2"
                label="Data Início"
                v-model="form.filters.dataInicio"
                removeIcon
                outlined
                dense
              ></sigfoco-date-picker>
              <sigfoco-date-picker
              :cols="2"
                v-model="form.filters.dataFim"
                label="Data Final"
                removeIcon
                outlined
                dense
              ></sigfoco-date-picker>
            </v-row>
             <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarRelatorios"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5 printable"
          :headers="getFilteredHeader(headersAnalitico)"
          :items="form.lists.listRelatorios"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
          show-expand
          sort-by="dataHoraDaAcao"
          :sort-desc="true"
          item-key="eventoId"
          :expanded.sync="expanded"
        >
          <template v-slot:[`item.nome`]="{ item }">
            {{ item.nome }}
          </template>
          <template v-slot:[`item.nomeDeExibicao`]="{ item }">
            {{ item.nomeDeExibicao }}
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.situacao"></sigfoco-label-ativo-inativo>
          </template>
          <template v-slot:[`item.dataHoraDaAcao`]="{ item }">
            {{ $formatarDataHora(item.dataHoraDaAcao) }}
          </template>
          <template v-slot:[`item.acao`]="{ item }">
            {{ item.acao }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td class="abas" :colspan="headers.length">
              <v-chip-group active-class="primary--text" column>
                <v-chip 
                  class="chip-permissao" 
                  v-for="(permissao,  i) in item.permissoes" 
                  :key="i"
                >
                  <v-icon class="abas" small>mdi-account-multiple</v-icon>
                  {{ permissao.nomeDeExibicao }}
                </v-chip>
              </v-chip-group>
            </td>
        </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorios.length"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
    import pageLoadingMixin from "mixins/page-loading.mixin";
    import RelatorioDeLog from "services/relatorios-log/manter-aba-log.service"
    export default {
        name: "RelatorioLogAba",
        mixins: [pageLoadingMixin, RelatorioDeLog],
    
        data: () => ({
        onReport: false,
        expanded: [],
        form: {
            filters: {
                aba: null,
                nomeDeExibicao: null,
                situacao: null,
                dataInicio: null,
                dataFim: null,
            },
            lists: {
                listRelatorios: [],
            },
            itemsPerPage: 10,
            geradorRelatorio: null,
            horaDaGeracao: null,
            totalAba: 0,
        },
        headersAnalitico: [
            { text: "Nome da Aba", align: "center", value: "nome" },
            { text: "Nome de Exibição", align: "center", value: "nomeDeExibicao" },
            { text: "Permissões", align: "center", value: "data-table-expand", onlyView: true },
            { text: "Permissões", align: "center", value: "data-table-expand", onlyReport: true },
            { text: "Situação", align: "center", value: "situacao" },
            { text: "Data/Hora da ação", align: "center", value: "dataHoraDaAcao" },
            { text: "Ação", align: "center", value: "acao" },
        ],
        }),
        methods: {
        getFilteredHeader(headers) {
            return headers.filter(header => {
            if (header.onlyView) return !this.onReport;
            if (header.onlyReport) return this.onReport;
            return true;
            });
        },
        async buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            if (!this.verificarFiltrosPreenchidos()) return;
    
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogGrupo(this.$montarParamsFilters(preparedRequest));
            this.processarRespostaRelatorio(data);
            } finally {
            this.hidePageLoading();
            }
        },
        validarDatas() {
        const { dataInicio, dataFim } = this.form.filters;
        
        if (dataInicio && dataFim) {
          if (new Date(dataFim) < new Date(dataInicio)) {
            this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
            return false;
          }
          if (new Date(dataInicio) > new Date(dataFim)) {
            this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
            return false;
          }
        }
        return true;
      },
    
        verificarFiltrosPreenchidos() {
          const { aba, situacao, nomeExibicao, dataInicio, dataFim } = this.form.filters;
          if (!aba && situacao == null && !nomeExibicao && !dataInicio && !dataFim) {
              this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
              return false;
          }
          
          return true;
        },
    
        async baixarCSVRelatorio() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogCSVGrupo(this.$montarParamsFilters(preparedRequest));
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeLogDeAbaCSV`);
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
    
        async baixarRelatorioPdf() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogPDFGrupo(this.$montarParamsFilters(preparedRequest));
            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeLogDeAba.pdf");
            document.body.appendChild(link);
            link.click();
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
        prepararRequisicao() {
            return {
            nome: this.form.filters.aba,
            nomeExibicao: this.form.filters.nomeDeExibicao,
            dataInicio: this.form.filters.dataInicio,
            dataFim: this.form.filters.dataFim,
            ativo: this.form.filters.situacao,
            };
        },
    
        processarRespostaRelatorio(data) {
            this.form.geradorRelatorio = data.relatorio.geradorRelatorio;
            this.form.horaDaGeracao = data.relatorio.horaDaGeracao;
            this.form.length = data.relatorio?.totalAba;
            this.form.lists.listRelatorios = data.relatorio?.logsGrupo;
        },

        resetForm() {
          this.form.filters.dataInicio = null;
          this.form.filters.dataFim = null;
    
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicio', null);
            this.$set(this.form.filters, 'dataFim', null);
          });
          this.form.filters.aba = null;
          this.form.filters.nomeDeExibicao = null;
          this.form.filters.situacao = null;

          this.form.lists.listRelatorios = [];
          this.expanded = [];
        }
      },
    };
</script>
<style scoped>
.permissoes {
  padding: 1em !important;
  text-align: center;
  font-weight: 500;
}
.permissao {
  padding-right: 0.5em;
}
</style>